import { Box } from "@similarweb/ui-components/foundations";

import { useSubtitleFilters } from "app/custom-hooks/useSubtitleFilters";
import { WidgetContainer } from "app/components/React/WidgetContainer/WidgetContainer";
import { translate } from "app/filters/i18nFilter";

import { TrafficShareBarChart } from "./TrafficShareBarChart/TrafficShareBarChart";
import type { ApiTotalData } from "./TrafficShareBarChart/types";

interface IMarketingChannelsTrafficShareWidgetProps {
    isLoading: boolean;
    apiData: ApiTotalData;
}

export const MarketingChannelsTrafficShareWidget = ({
    isLoading,
    apiData,
}: IMarketingChannelsTrafficShareWidgetProps) => {
    const subtitleFilters = useSubtitleFilters("date", "country", "webSource");
    const hasNoData = Boolean(apiData == null && !isLoading);

    return (
        <WidgetContainer
            withBorder
            automationId="traffic-share-bar-chart"
            title={translate("industry.trafficsources.piechart.title")}
            tooltip={translate("industry.trafficsources.piechart.title.tooltip")}
            noData={hasNoData}
            subtitleFilters={subtitleFilters}
        >
            <Box padding="25px">
                <TrafficShareBarChart
                    isLoading={isLoading}
                    apiData={apiData}
                />
            </Box>
        </WidgetContainer>
    );
};
